/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import {useStore} from '../../../../store/store';
import {observer} from 'mobx-react';
import PageWrapper from '../../../modules/PageWrapper';
import Filters from '../../../table/new/filters/Filters';
import Presets from '../../../table/new/Presets';
import {getFilters} from './getFilters';
import {facebookStatisticsFilters} from './filtersConfigs';
import {facebookStatisticsGroups} from './groupsConfigs';
import TableWrapper from '../../../table/new/TableWrapper';
import Columns from '../../../table/new/Columns';
import {baseFields} from '../../../table/new/customizationTable';
import BlankSheet from '../../../table/new/BlankSheet';
import FullScreen from '../../../table/new/FullScreen';
import Refresh from '../../../table/new/Refresh';
import ResultsCount from '../../../table/new/ResultsCount';
import Navigation from '../../../modules/NavigationBloggers';

const Statistics = () => {
  const store = useStore();
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);
  const [editItemId, setEditItemId] = useState(null);

  return (
    <PageWrapper
      firstTimeConfig='7day'
      prevTimeConfig={prevTimeConfig}
      breadcrumbs={[
        {title: 'Трекер'},
        {isSeparator: true},
        {title: 'Facebook'},
        {isSeparator: true},
        {
          title: 'Статистика Facebook',
          path: '/tracker/facebook/statistics',
          isActive: true,
        },
      ]}
      title='Статистика Facebook'
    >
      <TableWrapper
        setPrevTimeConfig={setPrevTimeConfig}
        prevTimeConfig={prevTimeConfig}
        getMethod={'Dashboard/Facebook/Statistics'}
        getFilters={getFilters}
        setEditItemId={setEditItemId}
        edit={null}
        defaultFilters={[
          {filter: 'state', isFixed: true, options: ['recently_created', 'with_data']},
        ]}
        defaultGroups={
          [
            // {group: 'bayer', isFixed: false},
            // {group: 'pixel', isFixed: false},
          ]
        }
        //на випадок якщо нам взагалі не потрібно показувати вибір груп
        hasHiddenGroups={false}
        baseFields={baseFields}
        disabledByDefault={[
          'click2reg',
          'click2cpa',
          'lead2fd',
          'lead2cpa',
          'chat2reg',
          'reg2cpa',
          'fd2cpa',
          'reg2rs',
          'chat2rs',
          'lead2rs',
          'click2rs',
        ]}
      >
        <Filters
          facebookStatisticsFilters={facebookStatisticsFilters}
          facebookStatisticsGroups={facebookStatisticsGroups}
          childrenRefresh={false}
          childrenHead={null}
          childrenPresets={
            <>
              <ResultsCount />
              <BlankSheet />
              <Columns columns={baseFields} />
              <Presets />
              <FullScreen />
            </>
          }
          childrenByFilters={<Refresh />}
          linksForOnGroup={
            store.roles.includes(6) || store.roles.includes(7)
              ? [
                  {link: '', title: 'Общая'},
                  {link: 'day', title: 'День'},
                  {link: 'month', title: 'Месяц'},
                  {link: 'advertiser', title: 'Рекламодатель'},
                  {link: 'offer', title: 'Оффер'},
                  {link: 'app', title: 'Приложения'},
                  {link: 'traffic', title: 'Кампания'},
                  {link: 'source', title: 'Поток'},
                  {link: 'country', title: 'Страна'},
                ]
              : [
                  {link: '', title: 'Общая'},
                  {link: 'day', title: 'День'},
                  {link: 'month', title: 'Месяц'},
                  {link: 'advertiser', title: 'Рекламодатель'},
                  {link: 'offer', title: 'Оффер'},
                  {link: 'app', title: 'Приложения'},
                  {link: 'traffic', title: 'Кампания'},
                  {link: 'bayer', title: 'FB Байер'},
                  {link: 'source', title: 'Поток'},
                  {link: 'country', title: 'Страна'},
                ]
          }
        />
      </TableWrapper>
    </PageWrapper>
  );
};

export default observer(Statistics);
